const guestWriterInvites = [
	{
		path: '/community/guest-writer-invites',
		name: 'community-guest-writer-invites-list',
		component: () => import('@/views/community/guest-writer-invites/index.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
]

export default guestWriterInvites
